import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import type { MarkdownHeader } from '@/hooks/useMarkdownHeaders/types';
const capitalizeFirst = (text: string): string => {
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};
export const generateMarkdownHeaderId = (text: string): string => text.toLowerCase().replace(/^\d+\.\s*/, '').replace(/[^\w\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-').trim();
const formatTitle = (text: string): string => {
  const withoutNumber = text.replace(/^\d+\.\s*/, '');
  const minorWords = ['de', 'da', 'do', 'e', 'ou', 'para', 'com', 'em', 'a', 'o', 'as', 'os', 'das', 'dos'];
  return withoutNumber.toLowerCase().split(' ').map((word, index) => {
    if (index === 0) return capitalizeFirst(word);
    if (minorWords.includes(word)) return word;
    return capitalizeFirst(word);
  }).join(' ');
};
interface UseMarkdownHeadersProps {
  markdown: string;
  columnsCount?: number;
}
interface UseMarkdownHeaders {
  columns: MarkdownHeader[][];
}
const useMarkdownHeaders = t0 => {
  const $ = _c(11);
  const {
    markdown,
    columnsCount: t1
  } = t0;
  const columnsCount = t1 === undefined ? 3 : t1;
  let t2;
  bb0: {
    if (!markdown) {
      let t3;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [];
        $[0] = t3;
      } else {
        t3 = $[0];
      }
      t2 = t3;
      break bb0;
    }
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = /^(#{2,4})\s+(.+)$/gm;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    const headerRegex = t3;
    let extractedHeaders;
    if ($[2] !== markdown) {
      extractedHeaders = [];
      let match;
      while ((match = headerRegex.exec(markdown)) !== null) {
        const level = match[1].length;
        const text = match[2].trim();
        const id = generateMarkdownHeaderId(text);
        const numberMatch = text.match(/^(\d+)\.\s*/);
        const number = numberMatch ? numberMatch[1] : "";
        const title = formatTitle(text.replace(/^\d+\.\s*/, ""));
        extractedHeaders.push({
          id,
          title,
          level,
          number
        });
      }
      $[2] = markdown;
      $[3] = extractedHeaders;
    } else {
      extractedHeaders = $[3];
    }
    t2 = extractedHeaders;
  }
  const headers = t2;
  let t3;
  if ($[4] !== headers) {
    t3 = headers.filter(_temp);
    $[4] = headers;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const groupedHeaders = t3;
  let cols;
  if ($[6] !== columnsCount || $[7] !== groupedHeaders) {
    cols = Array.from({
      length: columnsCount
    }, _temp2);
    groupedHeaders.forEach((header, index) => {
      cols[index % columnsCount].push(header);
    });
    $[6] = columnsCount;
    $[7] = groupedHeaders;
    $[8] = cols;
  } else {
    cols = $[8];
  }
  const columns = cols;
  let t4;
  if ($[9] !== columns) {
    t4 = {
      columns
    };
    $[9] = columns;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default useMarkdownHeaders;
function _temp(h) {
  return h.level === 2;
}
function _temp2() {
  return [];
}